import React from 'react';
import { Routes, Route, Navigate, Outlet, useLocation } from 'react-router-dom';
// import ProtectedRoute from '../components/protected-routes';
import ForgotPassword from '../pages/auth/forgot-password';
import Login from '../pages/auth/login';
import Signup from '../pages/auth/sign-up';
import AuthLayout from '../layout/auth-layout';
import EmailVerification from '../pages/auth/email-verification-confirmation';
import Dashboard from '../pages/components/dashboard/dasboard';
import ProtectedRoute from '../components/protected-routes';
// import useIdleTimer from '../hooks/useIdleTimer';
import Layout from '../layout/main-layout';
import Setting from '../pages/components/setting/setting';
import KybUpdate from '../pages/components/setting/kyb-update/kyb-update';
import StartKyb from '../pages/onboarding/start-kyb';
import KybSession from '../pages/onboarding/kyb/kyb-session';
import SuccessPage from '../pages/shared/success-page';
import GuestRoute from '../components/guest-route';
import NewPayout from '../components/dashboard/new-payout';
import KYBVerificationFailed from '../pages/onboarding/kyb-verification-failed';
import Transactions from '../pages/transactions/transactions';
import InternalServer from "../pages/shared/internal-server-error";

const ProtectedLayout: React.FC = () => {
  // useIdleTimer(300000); // Only applies to protected routes

  return (
    <Layout>
      <Outlet /> {/* This is where child routes will render */}
    </Layout>
  );
};

const SendMoneyLayout: React.FC = () => {
  return (
    <div>
      <Outlet /> {/* Render nested routes like "/send/transfers" here */}
    </div>
  );
};

const AppRoutes: React.FC = () => {
  // useIdleTimer(120000);
  const location = useLocation();
  const pageType = location.pathname.includes('login') ? 'login' : 'signup';

  return (
    <Routes>
      <Route path="/" element={<Navigate to="/login" />} />
      <Route path="/internal-server-error" element={<InternalServer />} />

      {/* Guest Routes */}
      <Route element={<GuestRoute />}>
        <Route element={<AuthLayout pageType={pageType} />}>
          <Route path="signup" element={<Signup />} />
          <Route path="login" element={<Login />} />
        </Route>
        <Route path="forgot-password" element={<ForgotPassword />} />
        <Route path="verified-email" element={<EmailVerification />} />
        <Route path="success" element={<SuccessPage />} />
      </Route>

      {/* Onboarding Routes */}
      <Route element={<ProtectedRoute />}>
        <Route path="/start-kyb" element={<StartKyb />} />
        <Route path="/kyb-session" element={<KybSession />} />
        <Route path="/dashboard/new-payout" element={<NewPayout />} />
        <Route path="/kyb-failed" element={<KYBVerificationFailed />} />

        {/* <Route path="/transactions" element={<Transactions />} /> */}

      </Route>

      <Route
        element={
          <ProtectedRoute>
            <ProtectedLayout /> {/* Idle timer is applied here */}
          </ProtectedRoute>
        }
      >
        {/* Child routes */}
        {/* Route for Dashboard */}
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/transactions" element={<Transactions />} />

        {/* Route for KYB Setup */}
        <Route path="/send" element={<SendMoneyLayout />}>
          {/* Nested route "/send/transfers" */}
        </Route>
        <Route path="settings" element={<Setting />} />
        <Route path="settings/kyb-update" element={<KybUpdate />} />
      </Route>
    </Routes>
  );
};

export default AppRoutes;
